import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const UsedByContainer = styled(Box)({
  mt: "26px"
}); 